import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { Constant } from "../../Constant";
import * as yup from "yup";
import Header from "../../component/Header/Header";
import { Box, Container, Grid } from "@material-ui/core";
import Navbar from "../../component/Navbar/Navbar";
import StepHeader from "../../component/StepHeader/StepHeader";
import { initialForm, setCurrentStep } from "../../redux/action";
import { getCurrentStep } from "../../redux/selector";
import DatePickerSample from "./DatePickerSample";

function DatePickerSampleForm() {
    const { t, i18n } = useTranslation();

    const formId = "SampleForm";
    const stepNames = ["Date Picker Sample", "Summary"];

    //init set up
    const dispatch = useDispatch();
    const currentStep = useSelector(getCurrentStep());
    useEffect(() => {
        dispatch(initialForm("SampleForm"));
        dispatch(setCurrentStep("DatePickerSample"));
    }, []);

    const renderStep = (step) => {
        switch (step) {
            case "DatePickerSample":
                return <DatePickerSample />;
            default:
                break;
        }
    };

    const getParentStep = (step) => {
        switch (step) {
            case "DatePickerSample":
                return {
                    step: 0,
                    stepName: "Date Picker Sample",
                };
            case "Summary":
                return {
                    step: 1,
                    stepName: "Summary",
                };
            default:
                break;
        }
    };

    return (
        <main>
            <Container>
                <Box className="wrapper personalInfo">
                    <Header formName={formId} />
                    <Box className="mainWrapper">
                        <Navbar
                            stepNames={stepNames}
                            step={getParentStep(currentStep)?.step}
                        />
                        <Box className="contentWrapper">
                            <StepHeader
                                title={getParentStep(currentStep)?.stepName}
                                step={getParentStep(currentStep)?.step}
                            />
                            {renderStep(currentStep)}
                        </Box>
                    </Box>
                </Box>
            </Container>
        </main>
    );
}

export default DatePickerSampleForm;
